import { Twitch, Youtube, Instagram, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useLanguage } from "@/i18n/LanguageContext";

const PLATFORMS = [
  { key: "twitch", icon: Twitch, name: "Twitch", handle: "@DottorFabio", url: "https://www.twitch.tv/DottorFabio", color: "#9146FF" },
  { key: "youtube", icon: Youtube, name: "YouTube", handle: "@fabiocomelli", url: "https://www.youtube.com/@fabiocomelli?sub_confirmation=1", color: "#FF4444" },
  { key: "instagram", icon: Instagram, name: "Instagram", handle: "@fabio_comelli", url: "https://www.instagram.com/fabio_comelli/", color: "#E1306C" },
];

const SocialSection = () => {
  const { t } = useLanguage();
  return (
    <section className="border-t border-white/10 px-6 py-24 md:px-12" data-testid="social-section">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <p className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-neon">{t.social.kicker}</p>
          <h2 className="font-display text-4xl font-extrabold uppercase tracking-tight sm:text-5xl" data-testid="social-title">
            {t.social.title}
          </h2>
        </Reveal>
        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-3">
          {PLATFORMS.map((p, i) => (
            <Reveal key={p.key} delay={i * 0.1}>
              <a
                href={p.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`social-${p.key}-button`}
                className="group flex h-full flex-col border bg-surface p-8 transition-transform duration-300 hover:-translate-y-1.5"
                style={{ borderColor: `${p.color}45` }}
              >
                <p.icon className="h-7 w-7" style={{ color: p.color }} />
                <p className="mt-6 font-display text-xl font-bold">{p.name}</p>
                <p className="mt-1 font-mono text-xs text-muted2">{p.handle}</p>
                <span className="mt-6 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em]" style={{ color: p.color }}>
                  {t.social[p.key]}
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialSection;
